import { UIObject } from "uicore-ts"


/**
 * A template literal tag to enable CSS highlighting in IDEs.
 * Example: css` .myClass { color: red; } `
 */
export function css(strings: TemplateStringsArray, ...values: any[]): string {
    // Simply combine the strings and values to return a valid CSS string
    return strings.reduce((acc, str, i) => acc + str + (values[i] ?? ''), '');
}


export class RHViewUtils extends UIObject {
    
    
    static injectCSS(cssText: string, id?: string) {
        // Prevent duplicate injection if an ID is supplied
        if (id && document.getElementById(id)) {
            return
        }
        
        const style = document.createElement("style")
        if (id) {
            style.id = id
        }
        
        style.textContent = cssText
        document.head.appendChild(style)
    }
    
    
    //function snapshotElement(element) {
    //   const clone = element.cloneNode(true);
    //
    //   function copyStyles(source, target) {
    //     const computed = window.getComputedStyle(source);
    //     let style = '';
    //
    //     for (const prop of computed) {
    //       style += `${prop}:${computed.getPropertyValue(prop)};`;
    //     }
    //
    //     target.setAttribute('style', style);
    //   }
    //
    //   function copyPseudo(source, target, pseudo) {
    //     const computed = window.getComputedStyle(source, pseudo);
    //     if (!computed || computed.content === 'none') return;
    //
    //     const pseudoEl = document.createElement('span');
    //     pseudoEl.textContent = computed.content.replace(/^["']|["']$/g, '');
    //
    //     let style = 'position:absolute;pointer-events:none;';
    //     for (const prop of computed) {
    //       style += `${prop}:${computed.getPropertyValue(prop)};`;
    //     }
    //
    //     pseudoEl.setAttribute('style', style);
    //
    //     if (pseudo === '::before') {
    //       target.prepend(pseudoEl);
    //     } else {
    //       target.append(pseudoEl);
    //     }
    //   }
    //
    //   function traverse(source, target) {
    //     copyStyles(source, target);
    //     copyPseudo(source, target, '::before');
    //     copyPseudo(source, target, '::after');
    //
    //     const sourceChildren = source.children;
    //     const targetChildren = target.children;
    //
    //     for (let i = 0; i < sourceChildren.length; i++) {
    //       traverse(sourceChildren[i], targetChildren[i]);
    //     }
    //   }
    //
    //   traverse(element, clone);
    //   return clone.outerHTML;
    // }
    
    
    
}






